import {isFunction} from "~/lib/helpers/guards";

export default class Evented {

  protected listeners: Map<string, Function[]>;

  constructor() {
    this.listeners = new Map();
  }

  on(type: string, callback: (evt: Event) => void): this {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, []);
    }
    this.listeners.get(type).push(callback);
    return this;
  }

  off(type: string, callback: (evt: Event) => void): this {
    if (!this.listeners.has(type)) {
      return this;
    }
    const stack = this.listeners.get(type);
    // tslint:disable-next-line one-variable-per-declaration
    for (let i = 0, l = stack.length; i < l; i++) {
      if (stack[i] === callback) {
        stack.splice(i, 1)
        return this;
      }
    }
    return this;
  }

  dispatchEvent (event: Event) {
    if (!this.listeners.has(event.type)) {
      return true;
    }
    const stack = this.listeners.get(event.type).slice();
    for (let i = 0, l = stack.length; i < l; i++) {
      if (!event.defaultPrevented) {
        isFunction(stack[i]) && stack[i].call(this, event);
      }
    }
    return !event.defaultPrevented;
  }
}
